export default __webpack_public_path__ + "static/media/Raupe.aa86492d.png";